import { ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiTypes } from '@hyundai/ng-common-lib';
import { VehicleCardComponent } from '../../components/vehicle-card/vehicle-card.component';

@Component({
    standalone: true,
    imports: [VehicleCardComponent],
    selector: 'lib-vehicle-list',
    templateUrl: './vehicle-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class VehicleListComponent {
    activatedRoute = inject(ActivatedRoute);

    vehicles = input.required<ApiTypes.Vehicles>();
}
